module.exports = __webpack_public_path__ + "img/selected1-min.1799e54b.png";